<script>
    import OpbouwDataset from '../data/OpbouwDataset.svelte';
</script>
<section data-step="5" class="step">
    <div class="newchapter">
        <h1 class="chapter">IV. De Opbouwfase</h1>
        <h2 class="chaptersubtitle">Ome DUO betaalt (nog)!</h2>
    </div>

    <div class="row ">
        <div class="twelve columns">
            <h2>September 2015 - een fris begin </h2>
            <p>Je start met studeren in [september 2015]! Vanaf dit moment krijg je studiefinanciering met de spelregels van het leenstelsel. Je schuld begint pas op te bouwen zodra je je aanmeldt voor bijvoorbeeld het studenten-OV of begint te lenen voor je studie.
            <br/> Als je elke maand leent ziet je opbouwfase er zo uit:</p>   

            <p>Zoals je ziet gebeurt er nog niet zo veel, behalve dan dat je schuld oploopt. Iets waar je wel al rustig rekening mee moet gaan houden, is rente.</p>
            <OpbouwDataset />

        </div>
    </div>
    <div class="row ">
        <div class="twelve columns">
            <h2>Rente <small>(vervolg)</small></h2>
            <p>Let op: omdat je wel rente moet betalen, maar dat in deze fase nog niet overmaakt, komt deze bovenop je bestaande schuld terecht! Daar betaal je dan weer rente over, die weer op je schuld terechtkomt etc, etc.. dus je schuld kan door rente ook stijgen zonder dat je daar extra voor hoeft te lenen!</p>
            <br/>
            <p>Studeer lekker door, de volgende stap gaat in als je je bent uit- of afgestudeerd.</p>
        </div>
    </div>
</section>

